import { gql } from 'apollo-angular';

export const VEHICLE_FRAGMENT = gql`
  fragment Details on SavedVehicle {
    id
    name
    vehicleType
    manufacturer {
      id
      name
      shortName
    }
    model {
      id
      name
    }
    beginYearMonth
    endYearMonth
    period
    images {
      url50
      url100
      url200
      url400
      url800
    }
    kbaNumbers
    driveType
    bodyStyle
    valves
    fuelMixtureFOrmationType {
      id
      name
    }
    fuelType {
      id
      name
    }
    engineType {
      id
      name
    }
    powerHp
    powerKw
    cylinders
    capacity {
      cc
      liters
    }
    engines {
      id
      code
    }
  }
`;

export const ASSET_FRAGMENT = gql`
  fragment Asset on Asset {
    id
    width
    height
    name
    preview
    tags {
      id
      value
    }
    focalPoint {
      x
      y
    }
  }
`;

export const CART_FRAGMENT = gql`
  fragment Cart on Order {
    id
    code
    state
    active
    updatedAt
    orderPlacedAt
    lines {
      id
      featuredAsset {
        ...Asset
      }
      unitPrice
      unitPriceWithTax
      discountedUnitPriceWithTax
      quantity
      linePriceWithTax
      discountedLinePriceWithTax
      proratedLinePriceWithTax
      productVariant {
        id
        name
        sku
        stockLevel
        product {
          name
          slug
          customAttributes {
            manufacturer {
              id
              name
              code
              asset {
                id
                preview
                focalPoint {
                  x
                  y
                }
              }
            }
          }
          description
        }
      }
      discounts {
        amount
        amountWithTax
        description
        adjustmentSource
        type
      }
    }
    totalQuantity
    subTotal
    subTotalWithTax
    total
    totalWithTax
    shipping
    shippingWithTax
    shippingLines {
      priceWithTax
      shippingMethod {
        id
        code
        name
        description
      }
    }
    discounts {
      amount
      amountWithTax
      description
      adjustmentSource
      type
    }
    customFields {
      customerComments
    }
  }
  ${ASSET_FRAGMENT}
`;

export const COUNTRY_FRAGMENT = gql`
  fragment Country on Country {
    id
    code
    name
    enabled
  }
`;

export const ORDER_ADDRESS_FRAGMENT = gql`
  fragment OrderAddress on OrderAddress {
    fullName
    company
    streetLine1
    streetLine2
    city
    province
    postalCode
    country
    phoneNumber
  }
`;

export const ADDRESS_FRAGMENT = gql`
  fragment Address on Address {
    id
    fullName
    company
    streetLine1
    streetLine2
    city
    province
    postalCode
    country {
      id
      code
      name
    }
    phoneNumber
    defaultShippingAddress
    defaultBillingAddress
  }
`;

export const ERROR_RESULT_FRAGMENT = gql`
  fragment ErrorResult on ErrorResult {
    errorCode
    message
  }
`;
